import React from 'react';
import DashboardLayout from '../../../examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from '../../../examples/Navbars/DashboardNavbar';
import RefundsTab from './components/RefundsTab';

const BookingRefundsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="mt-6 rounded-lg bg-white p-6 shadow-lg">
        <div className="mb-4">
          <h2 className="text-xl font-bold text-gray-800">Booking Refunds</h2>
          <p className="mt-1 text-sm text-gray-500">
            All booking refund requests from `admin/booking/refunds`.
          </p>
        </div>

        <RefundsTab />
      </div>
    </DashboardLayout>
  );
};

export default BookingRefundsPage;
